import { useState } from 'react';
import { Button, ComboButton } from '@/form/FormComponents'
import { useMenu } from '@/components/Menu'
import { useShareModal } from '@/components/FilesystemShareModals';

export function ShareButton({ file }) {
  const [shareLoading, setShareLoading] = useState(false);

  const [handleShare] = useShareModal({ setShareLoading, refreshOnShareTypeChange: true });
  
  const { handleOnClick: handleShareMenuOnClick } = useMenu({
    menuItems: [
      {
        icon: 'link',
        label: 'Copy link',
        onClick: () => {navigator.clipboard.writeText(`https://sapientclinician.com/${file.type}s/${file.item_id}`)},
      }
    ],
  });

  return (
    <ComboButton>
      <Button text="Share" icon={file._share_type ? {"people": "account-multiple-outline", "organization": "domain", "public": "public"}[file._share_type] : "lock-outline"} small_icon={true} disabled={!["edit", "owner"].includes(file._level)} onClick={() => {handleShare(file)}} loading={shareLoading}/>
      <Button icon="menu-down-enlarged" onClick={handleShareMenuOnClick}/>
    </ComboButton>
  )
}